import { AxiosResponse } from 'axios';
import { http } from '@/services/http.service';
import { IRegisterUser, IUserLogin } from '@/types/common/general';
import { USER_LOGIN_PATH, USER_LOGOUT_PATH, USER_SIGN_UP_PATH } from '@/constant/routers/path';

export const login = (user: IUserLogin): Promise<AxiosResponse> => {
  return http.post(USER_LOGIN_PATH, { user });
};

export const logout = (): Promise<AxiosResponse> => {
  return http.delete(USER_LOGOUT_PATH);
};

export const register = (user: IRegisterUser): Promise<AxiosResponse> => {
  return http.post(USER_SIGN_UP_PATH, { user });
};
